import React from 'react';

export default function HoppyMascot({ primaryColor = '#e31937', size = 64 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <line x1="50" y1="8" x2="50" y2="18" stroke={primaryColor} strokeWidth="3" strokeLinecap="round" />
      <circle cx="50" cy="6" r="4" fill={primaryColor} />
      <rect x="18" y="18" width="64" height="54" rx="20" fill="#ffffff" />
      <rect x="18" y="18" width="64" height="54" rx="20" stroke={primaryColor} strokeWidth="3" />
      <circle cx="14" cy="45" r="7" fill={primaryColor} />
      <circle cx="86" cy="45" r="7" fill={primaryColor} />
      <rect x="18" y="28" width="64" height="8" fill={primaryColor} />
      <circle cx="38" cy="52" r="7" fill="#14141c" />
      <circle cx="62" cy="52" r="7" fill="#14141c" />
      <circle cx="40" cy="50" r="2" fill="#ffffff" />
      <circle cx="64" cy="50" r="2" fill="#ffffff" />
      <path d="M40 62 q10 8 20 0" stroke="#14141c" strokeWidth="3" strokeLinecap="round" fill="none" />
      <rect x="38" y="72" width="24" height="10" rx="4" fill="#ffffff" opacity="0.9" />
      <rect x="38" y="72" width="24" height="4" rx="2" fill={primaryColor} />
    </svg>
  );
}
